export default __webpack_public_path__ + "static/media/zaxe_logo.750f5d6d.svg";